import * as React from 'react';

import type {EventFragmentFull as Event} from 'nutshell-graphql-types';

import {TimelineBannerModal} from './timeline-banner-modal';

type Props = {
    event: Event;
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
};

export function TimelineModalEmailInteraction(props: Props) {
    const {event} = props;
    if (event.payload && event.payload.__typename === 'EmailInteraction') {
        const entity = event.payload;
        const emailDelivery = entity.emailDelivery;
        const actor = emailDelivery ? emailDelivery.primaryContact : undefined;
        const bodyHtml = emailDelivery && emailDelivery.email && emailDelivery.email.bodyHtml;

        const isEdition = Boolean(emailDelivery && emailDelivery.edition);

        if (actor && bodyHtml) {
            return (
                <TimelineBannerModal
                    isOpen={props.isOpen}
                    isLoading={props.isLoading}
                    onClose={props.onClose}
                    timestamp={event.changeTime}
                    actor={actor}
                    entryType={entity.__typename}
                    changeType='ADDED'
                    entity={entity}
                    iconVariant='email-outreach-sent'
                    bodyHtml={bodyHtml}
                    isEdition={isEdition}
                />
            );
        }
    }

    return null;
}
